import styled from "styled-components";

import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import db, {doc, getDoc} from "../firebase";

function Detail(props) {
    const id = useParams().id;
    // let movie = null;
    const docRef = doc(db, "movies", id);

    const [movie, setMovie] = useState(null);

    // console.log(docSnap.data());
    useEffect(() => {
        getDoc(docRef).then(res => {
            if(res.exists()){
                setMovie(res.data())
            }

            else{
                console.log("no such document");
            }
        }).catch(error => console.log('Error getting document: ',error.message));
    }, [id]);
    return (
        <Container>
            {

                movie &&
                <>
                    <Background>
                        <img src={movie.backgroundImg} alt={movie.title}/>
                    </Background>

                    <ImageTitle>
                        <img src={movie.titleImg} alt={movie.title}/>
                    </ImageTitle>

                    <ContentMeta>
                        <Controls>
                            <Player>
                                <img src="/images/play-icon-black.png" alt=""/>
                                <span>Play</span>
                            </Player>
                            
                            <Trailer>
                                <img src="/images/play-icon-white.png" alt=""/>
                                <span>Trailer</span>
                            </Trailer>

                            <AddList>
                                <span />
                                <span />
                            </AddList>

                            <GroupWatch>
                                <div>
                                    <img src="/images/group-icon.png" alt=""/>
                                </div>
                            </GroupWatch>
                        </Controls>

                        <Subtitle>{movie.subTitle}</Subtitle>
                        <Description>{movie.description}</Description>
                    </ContentMeta>
                </>
            }

        </Container>
    );
}

const Container = styled.div`
    position: relative;
    min-height: calc(100vh - 250px);
    overflow-x: hidden;
    margin-top: 72px;
    display: block;
    padding: 0 calc(3.5vw + 5px);
`

const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    opacity: 0.8;
    
    img{
        width: 100vw;
        height: 100vh;
        
        @media (max-width: 768px){
            width: initial;
        }
    }
`

const ImageTitle = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    margin: 0 auto;
    height: 30vw;
    min-height: 170px;
    width: 100%;
    padding-bottom: 24px;
    -webkit-box-pack: start;
    
    img{
        max-width: 600px;
        min-width: 200px;
        width: 35vw;
    }
`

const ContentMeta = styled.div`
    max-width: 874px;
`

const Controls = styled.div`
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    margin: 24px 0px;
    min-height: 56px;
`

const Player = styled.div`
    font-size: 15px;
    letter-spacing: 1.6px;
    text-align: center;
    text-transform: uppercase;
    margin: 0 22px 0 0;
    padding: 0 24px;
    height: 56px;
    border-radius: 4px;
    background-color: rgb(249, 249, 249);
    border-none;
    color: rgb(0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
    img{
        width: 32px;
    }
    
    &:hover{
        background-color: rgb(198, 198, 198);
    }
    
    @media (max-width: 768px){
        height: 45px;
        padding: 0 22px;
        font-size: 12px;
        margin: 0 10px 0 0;
        img{
            width: 25px;
        }
    }
`

const Trailer = styled(Player)`
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgb(249, 249, 249);
    color: rgb(249, 249, 249);
    
    &:hover{
        background: rgba(0, 0, 0, 0.5);
    }
`

const AddList = styled.div`
    margin-right: 16px;
    height: 44px;
    width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    border: 2px solid rgb(249, 249, 249);
    cursor: pointer;
    
    span{
        background-color: rgb(249, 249, 249);
        display: inline-block;
        
        &:first-child{
            height: 2px;
            transform: translate(1, 0);
            width: 16px;
        }
        
        &:nth-child(2){
            height: 16px;
            width: 2px;
            transform: translateX(-8.5px) rotate(0deg);
        }
    }
`

const GroupWatch = styled.div`
    height: 44px;
    width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: rgb(249, 249, 249);
    cursor: pointer;
    
    div{
        height: 40px;
        width: 40px;
        border-radius: 50%;
        background: rgb(0, 0, 0);
        display: flex;
        justify-content: center;
        align-items: center;
        
        img{
            width: 100%;
        }
    }
`

const Subtitle = styled.div`
    color: rgb(249, 249, 249);
    font-size: 15px;
    min-height: 20px;
    
    @media (max-width: 768px){
        font-size: 12px;
    }
`

const Description = styled.div`
    line-height: 1.4;
    font-size: 20px;
    padding: 16px 0;
    
    color: rgb(249, 249, 249);
    
    @media (max-width: 768px){
        font-size: 14px;
    }
`

export default Detail;